// src/utils/studentNames.js
/* Short names that stay different: "David N." for one David N.,
   but "David Nas." and "David Noh." when two students would both be "David N.".
   people: [{ first, last }] -> function (first, last) => short name */
const clean = (v) => String(v || '').trim().replace(/\s+/g, ' ');
const cap = (v) => v.charAt(0).toUpperCase() + v.slice(1);

export const makeShortNames = (people) => {
  const groups = new Map(); // "david|n" -> Set of last names
  people.forEach(({ first, last }) => {
    const f = clean(first).toLowerCase();
    const l = clean(last).toLowerCase();
    const k = `${f}|${l.charAt(0)}`;
    if (!groups.has(k)) groups.set(k, new Set());
    groups.get(k).add(l);
  });

  return (first, last) => {
    const f = cap(clean(first));
    const l = clean(last);
    if (!l) return f || 'Student';
    const lastNames = [...(groups.get(`${f.toLowerCase()}|${l.charAt(0).toLowerCase()}`) || [])];
    let n = 1;
    if (lastNames.length > 1) {
      // fewest letters that tell them apart (at least 3, easier to read)
      n = 3;
      const low = l.toLowerCase();
      while (n < l.length && lastNames.some((o) => o !== low && o.slice(0, n) === low.slice(0, n))) n += 1;
    }
    const part = l.slice(0, n);
    return `${f} ${cap(part)}${n < l.length ? '.' : ''}`;
  };
};
